<template>
  <div class="zpl-wrapper">

    <div class="animation-overlay">
      <div class="gradient-bg"></div>
      <div class="woman-bg"></div>
      
      <div class="woman-big-dot">
        <!-- <svg class="woman-dots-head" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="556.828" height="605.641" viewBox="0 0 556.828 605.641"><defs><linearGradient id="a" y1="0.486" x2="1" y2="0.486" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#ae0b11"/><stop offset="1" stop-color="#e41429"/></linearGradient></defs><path class="a" d="M627.253,318.464c-2.752-22.225-8.88-58.572-37.023-75.916-3.063-3.271-6.075-6.438-9.19-9.762,9.242-21.913-8.36-31.415-20.251-43.514,1.61-3.479.623-5.867-2.8-7.321q-31.934-35.673-79.447-40.814-15.031-10.125-30.013-20.147c-2.441-5.764-3.791-15.474-7.737-16.72-49.122-15.525-97.465-44.656-149.546-5.348-19.576,14.747-41.125,28.4-66.465,32.765-74.1,61.376-132.462,132.307-143.315,232.627-24.509,129.71,62.675,237.092,166.214,295.873,86.249,48.966,170.265,15.37,246.959-16.98,44.4-18.641,98.918-49.122,107.279-112.315C643.87,464.323,635.821,389.654,627.253,318.464ZM428.845,273.081a3.4,3.4,0,0,1,0,.727c-.312-.208-.675-.363-.987-.571h0l-.312.156a13.437,13.437,0,0,0,.519-1.714h0l-.208,1.558ZM336.469,588.166l-.311.675-.312-.1Z" transform="translate(-77.292 -79.242)"/></svg> -->
      </div>

      <div class="woman-heart-cnt">
        <svg class="woman-heart" version="1.1" id="Layer_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1920px" height="1080px" viewBox="0 0 1920 1080" style="enable-background:new 0 0 1920 1080;" xml:space="preserve">
          <path class="st0" d="M968,634.5c-1.1-4.6-4-10.5-8.8-12.1c-4.9-1.6-10.9,1.8-14.5,4.9c-4.3,3.5-6.6,8.7-9.1,13.5
            c-1.4,2.8-2.8,5.6-4.1,8.4c-1.8-3.3-3.6-6.6-5.5-9.9c-2.5-4.2-5.4-8.4-9.7-11c-4.5-2.7-9.1-1.7-13.3,1c-4.2,2.7-6,6.5-6.7,11.4
            c-3,22.2,16.9,37.3,30,52.6l-0.2,0.2c-1.3,1.3-0.6,1.7,0.9,1.5c0.2,0,0.5-0.1,0.7-0.2c0.5,0.6,1.1,1.3,1.6,1.9
            c1.3,1.6,8.9-3.4,8-4.6c-0.7-0.9-1.4-1.8-2.2-2.7c8.6-8.1,17.7-16,24.8-25.3C966.2,655.8,970.6,645.2,968,634.5z M960.6,647.7
            c-0.1,1.1-0.3,2.1-0.5,3.1c-5.6,5.6-11,11.5-16.2,17.5c2.1-4.9,4.5-9.7,6.9-14.6c2-4,3.8-8,5.4-12.2c0.7-1.8,2.1-4.7,2.2-7.2
            c0,0.1,0.1,0.2,0.1,0.3C960.3,638.8,961.1,643.3,960.6,647.7z M941.3,641.6c2.2-4.5,4.3-9.6,7.4-13.6c2-2.5,5,0,7.2,2.8
            c-2.2,0.3-5.7,3.1-6.4,4.1c-5.1,6.5-9.8,13.2-14.2,20.1C937.2,650.5,939.2,646,941.3,641.6L941.3,641.6z M906.3,652.1
            c0.2-0.2,0.3-0.3,0.4-0.5c1.9-2.5,4-4.8,6.2-7c0.1,4.1-0.9,8.1-1.6,12.1c-0.3,1.4-0.5,2.8-0.8,4.2
            C908.9,658.2,907.4,655.3,906.3,652.1L906.3,652.1z M921.9,655.6l-3.7,4.4c0.5-2.8,1-5.6,1.5-8.5c0.3-1.4,0.5-2.8,0.7-4.2
            c1.2,2.2,2.4,4.5,3.5,6.7C923.2,654.6,922.5,655.1,921.9,655.6L921.9,655.6z M916.5,668.1l4.6-5.5c-0.3,3.7-0.5,7.3-0.8,11
            c-1.5-1.6-2.9-3.3-4.3-5C916.2,668.4,916.4,668.3,916.5,668.1L916.5,668.1z M929,660.3c1.9-0.8,3.6-2,5.1-3.4
            c-1.9,3-3.7,6.1-5.5,9.1C928.8,664.2,928.9,662.3,929,660.3L929,660.3z M904.9,634c0.2-0.7,0.5-1.4,0.8-2.1l0.4,0.1
            c0.9,0.7,2.5,1,3.5,1.8c0.9,0.6,1.7,1.3,2.5,2.1c1.1,1,2,2.1,3,3.3c-0.5,0.3-0.9,0.5-0.9,0.6c-3.2,2.4-6.3,5.1-9.1,8.1
            c0-0.1-0.1-0.3-0.1-0.4C903.8,643,903.8,638.4,904.9,634L904.9,634z M948.2,672c-4.8,5.3-10,10.2-15.2,15.1c-2.2-2.5-4.6-5-7-7.5
            c0.6-0.4,1.1-0.8,1.6-1.3c6.9-12.3,13.9-24.6,22-36.2c-0.6,1.7-1.4,3.4-1.8,4.6c-1.6,4.1-3.5,8.1-5.5,12.1
            c-3.9,8-7.9,15.9-10.1,24.5c-0.3,1.3,2.8,0,3-0.1c1.8-0.7,3.5-1.8,4.7-3.3c5.5-7.4,11.3-14.4,17.5-21.2
            C955.1,663.6,951.9,668.1,948.2,672z"/>
          </svg>
      </div>

      <div class="dots-cnt">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="1920px" height="1080px" viewBox="0 0 1920 1080" style="enable-background:new 0 0 1920 1080;" xml:space="preserve">
          <g id="Layer_3" class="bg-dots-1">
            <g transform="translate(-104.293 -24.836)">
              <g transform="translate(158.833 57.999)">
                <path class="st0" d="M1111.3,261.7c0.3-1.1,0.1-2.4-0.5-3.4c-0.1-0.2-0.2-0.3-0.2-0.5c0.6-0.7,0.1-1.3-0.3-1.9
                  c0.1-0.1,0.1-0.2,0-0.3c0,0,0,0-0.1,0c-0.5-1.1-1.4-2-2.6-2.5c-0.3-0.4-0.6-0.8-0.9-1.1c0-0.2,0-0.6-0.1-0.7
                  c-1.7-1.2-3.2-2.9-5.7-2c-0.9,0.4-1.9,0.6-2.9,0.5c-3.6,1.5-6.7,3.5-8.3,7.2c-2.5,4.7-0.4,9.8,2.9,13.3c2.7,2.9,6.4,2.6,9.7,2.3
                  c1.9-0.2,4.4-0.7,5.5-3C1110.2,267.5,1110.8,264.6,1111.3,261.7z M1104.2,257.6L1104.2,257.6L1104.2,257.6L1104.2,257.6
                  L1104.2,257.6L1104.2,257.6L1104.2,257.6L1104.2,257.6L1104.2,257.6z M1096.9,268.6L1096.9,268.6L1096.9,268.6L1096.9,268.6z"/>
                <g transform="translate(9.718)">
                  <path class="st1" d="M1142.1,223.5c1.1-0.3,2-1,2.4-2c0.1-0.1,0.2-0.3,0.3-0.4c0.9,0.2,1.1-0.6,1.4-1.1c0.1,0,0.2,0,0.2-0.1
                    c0,0,0,0,0-0.1c0.7-0.9,1-2.1,0.8-3.2c0.2-0.4,0.3-0.8,0.5-1.2c0.2-0.1,0.5-0.3,0.5-0.4c0.2-1.9,0.8-3.9-1-5.5
                    c-0.7-0.6-1.3-1.3-1.7-2.1c-2.8-2.2-5.9-3.7-9.6-3.3c-4.9,0.2-8.1,4.2-9.4,8.4c-1.1,3.5,0.8,6.3,2.6,8.8c1,1.5,2.6,3.2,4.9,3
                    C1136.9,225.3,1139.6,224.4,1142.1,223.5z M1142.1,215.9L1142.1,215.9L1142.1,215.9L1142.1,215.9L1142.1,215.9
                    C1142.1,215.9,1142.1,215.9,1142.1,215.9L1142.1,215.9L1142.1,215.9L1142.1,215.9z M1130,215.2L1130,215.2L1130,215.2
                    L1130,215.2z"/>
                  <path class="st0" d="M1126.2,250.2c0.6-0.1,1-0.5,1.3-1l0.1-0.2c0.5,0.1,0.6-0.3,0.7-0.6c0.1,0,0.1,0,0.1-0.1
                    c0.4-0.5,0.5-1.1,0.4-1.7c0.1-0.2,0.2-0.4,0.3-0.7c0.1-0.1,0.3-0.1,0.3-0.2c0.1-1,0.4-2-0.5-2.9c-0.4-0.3-0.7-0.7-0.9-1.1
                    c-1.4-1.2-3.2-1.9-5-1.7c-2.6,0.1-4.2,2.2-4.9,4.4c-0.6,1.8,0.4,3.3,1.4,4.6c0.5,1,1.5,1.5,2.6,1.6
                    C1123.5,250.9,1124.9,250.8,1126.2,250.2z M1126.2,246.2L1126.2,246.2L1126.2,246.2L1126.2,246.2L1126.2,246.2z M1119.9,245.8
                    L1119.9,245.8L1119.9,245.8L1119.9,245.8z"/>
                  <path class="st0" d="M1107.7,231.1c0.3-0.1,0.5-0.3,0.6-0.5l0.1-0.1c0.2,0,0.3-0.1,0.4-0.3c0,0,0,0,0.1,0c0,0,0,0,0,0
                    c0.2-0.2,0.3-0.5,0.2-0.8c0-0.1,0.1-0.2,0.1-0.3c0,0,0.1-0.1,0.1-0.1c0-0.5,0.2-1-0.3-1.4c-0.2-0.1-0.3-0.3-0.4-0.6
                    c-0.7-0.6-1.6-0.9-2.5-0.9c-1.2,0.1-2.2,1-2.5,2.2c-0.2,0.8,0.1,1.7,0.7,2.3c0.3,0.5,0.8,0.8,1.3,0.8
                    C1106.3,231.4,1107,231.4,1107.7,231.1z M1107.7,229.1L1107.7,229.1L1107.7,229.1L1107.7,229.1z M1104.5,228.9L1104.5,228.9z"/>
                  <path class="st0" d="M1094.1,211.2c0.4-0.1,0.7-0.3,0.8-0.7c0,0,0.1-0.1,0.1-0.1c0.3,0.1,0.4-0.2,0.5-0.4c0,0,0.1,0,0.1-0.1
                    c0.2-0.3,0.3-0.7,0.3-1.1c0.1-0.1,0.1-0.3,0.2-0.4c0.1,0,0.2-0.1,0.2-0.1c0.1-0.7,0.3-1.3-0.3-1.9c-0.3-0.2-0.5-0.4-0.6-0.7
                    c-0.9-0.8-2.1-1.2-3.3-1.1c-1.6,0.2-2.9,1.3-3.2,2.9c-0.2,1.1,0.1,2.2,0.9,3c0.3,0.6,1,1,1.7,1
                    C1092.3,211.7,1093.3,211.6,1094.1,211.2z M1094.1,208.6L1094.1,208.6L1094.1,208.6L1094.1,208.6L1094.1,208.6L1094.1,208.6
                    L1094.1,208.6L1094.1,208.6z M1089.9,208.3L1089.9,208.3L1089.9,208.3L1089.9,208.3z"/>
                </g>
                <path class="st0" d="M1146,233.2c0.1-0.3,0-0.6-0.1-0.8l-0.1-0.1c0.1-0.2,0-0.3-0.1-0.5c0,0,0,0,0-0.1c0,0,0,0,0,0
                  c-0.1-0.3-0.3-0.5-0.6-0.6c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1,0-0.2,0-0.2c-0.4-0.3-0.8-0.7-1.4-0.5c-0.2,0.1-0.5,0.1-0.7,0.1
                  c-0.9,0.3-1.6,0.9-2,1.7c-0.5,1.1-0.2,2.4,0.7,3.2c0.6,0.6,1.5,0.8,2.3,0.6c0.5,0,1-0.3,1.3-0.7
                  C1145.6,234.5,1145.9,233.9,1146,233.2z M1144.3,232.2L1144.3,232.2L1144.3,232.2L1144.3,232.2L1144.3,232.2L1144.3,232.2
                  L1144.3,232.2L1144.3,232.2L1144.3,232.2z M1142.5,234.8L1142.5,234.8L1142.5,234.8L1142.5,234.8z"/>
              </g>
              <path class="st1" d="M1240.3,249.5c-0.2-1.9-0.8-5-3.2-6.5c-0.3-0.3-0.5-0.6-0.8-0.8c0.8-1.9-0.7-2.7-1.7-3.7
                c0.1-0.2,0.1-0.4-0.1-0.6c0,0-0.1,0-0.1-0.1c-1.7-2-4.2-3.3-6.8-3.5c-0.9-0.6-1.7-1.2-2.6-1.7c-0.2-0.5-0.3-1.3-0.7-1.4
                c-4.2-1.3-8.4-3.8-12.9-0.5c-1.7,1.4-3.6,2.3-5.7,2.8c-6.4,5.3-11.4,11.4-12.3,20c-2.1,11.2,5.4,20.4,14.3,25.4
                c7.4,4.2,14.6,1.3,21.2-1.5c3.8-1.6,8.5-4.2,9.2-9.7C1241.7,262,1241,255.6,1240.3,249.5z M1223.2,245.6
                C1223.2,245.6,1223.2,245.6,1223.2,245.6C1223.2,245.6,1223.1,245.6,1223.2,245.6L1223.2,245.6l-0.1,0c0,0,0-0.1,0-0.1l0,0
                L1223.2,245.6L1223.2,245.6z M1215.3,272.6L1215.3,272.6L1215.3,272.6L1215.3,272.6z"/>
            </g>
          </g>
          <g id="Layer_4" class="bg-dots-2">
            <g transform="translate(126.268 104.191)">
              <path class="st1" d="M385.3,742.6c1.5-3.9,0-7.2-3.9-8.9c-2.6-1.4-5.7,1.1-7.2,3.7c-0.6,1.1,2.6,6.9,4.1,7.6
                C379.8,745.7,384.7,744.1,385.3,742.6z"/>
              <path class="st2" d="M340.3,718.9c2.6-2,2.6-6.2,0.1-9.2v0l0,0l0,0c-2-2.8-5.1-2.1-7.8-2.2c-1,0.1-0.9,1-1.1,1.7
                c-0.4,0.2-0.9,0.5-1.3,0.7c-1.4,0.9-1.3,2.3-1.4,3.7c0.2,0.4,0.4,0.8,0.6,1.2c-0.6,2.2,0.5,4.4,2.6,5.3
                C334.1,721.2,338.3,721.7,340.3,718.9z"/>
              <path class="st2" d="M435.4,765.1c-0.9,2,0.5,4.9,2.7,5.8c2.7,1.1,5.5,0.5,6.2-1.4c0.6-1.7-1.2-6.1-2.9-6.8
                C439.6,761.9,436.1,763.3,435.4,765.1z"/>
              <path class="st1" d="M430.6,722l-1.1,1.4c-2.1,2.6,0.3,4.3,1.5,5.8c1.2,1.4,3.2,2.6,5.2,0.7c2.1-1.6,2.2-3.6,1.1-5.9
                C436.1,720.6,433.4,719.8,430.6,722z"/>
              <path class="st1" d="M402.1,756.6c2.3,0.5,5.7-1.7,6.4-3.8c0.6-2-0.6-4.3-3.1-5.7c-1.7-0.9-5.1-0.2-6.5,1.4
                c-1.4,0.4-1.5,1.3-0.9,2.4c0.6,1.1,1.2,2.1,1.8,3.1c0.1,0,0.1,0,0.1-0.1l0,0l-0.1,0C399.5,755.8,400.8,756.3,402.1,756.6z"/>
              <path class="st2" d="M449.3,707.8c0.1,0.6,0.2,1.3,0.3,1.9c-0.7,2.1,1.5,2.6,2.2,2.6c1.7,0,4,0.7,5.1-1.5c0.6-1.2,1.4-2.5,0.2-3.8
                c-1.3-1.5-2.5-3.2-4.9-2.7C450.6,704.8,449.4,706.2,449.3,707.8z"/>
              <path class="st2" d="M369.9,712.3c1-1.7,0.6-3.9-1-5.1c-1.4-1.3-3.6-1.1-4.9,0.3c-0.1,0.1-0.1,0.1-0.2,0.2
                c-0.5,0.6-1.2,1.2-0.8,2.2c-0.8,2.2,1.1,3.2,2.4,3.5C366.8,713.7,368.9,714,369.9,712.3z"/>
              <path class="st2" d="M413.2,738.2c-0.6,1.8,1,2.3,1.8,3.3c1.1,0.4,2.1,0.5,2.5-0.8c0.5-1.3-0.2-2.7-1.5-3.3
                C415.1,737,413.8,736.7,413.2,738.2z"/>
              <path class="st1" d="M447.7,669.3l0.6-0.3c0.9,0.8,1.7,0.1,2.5-0.2c0.1,0.1,0.2,0.1,0.3,0.1c0,0,0,0,0.1-0.1
                c1.5-0.6,2.7-1.7,3.4-3.1c0.5-0.4,1-0.7,1.5-1.1c0.3,0,0.8,0.1,0.9-0.1c1.6-2.1,3.9-3.9,2.9-7.1c-0.4-1.2-0.6-2.5-0.4-3.8
                c-1.7-4.7-4.1-8.8-8.7-11.1c-5.9-3.5-12.6-1.2-17.3,2.8c-3.9,3.3-3.8,8-3.6,12.3c0.1,2.5,0.6,5.7,3.5,7.2c2.5,3.2,6.3,4.1,9.8,5
                C444.5,670,446.4,670.4,447.7,669.3z M449.1,661L449.1,661L449.1,661L449.1,661L449.1,661L449.1,661L449.1,661L449.1,661
                L449.1,661z M435.5,650.9L435.5,650.9L435.5,650.9L435.5,650.9z"/>
              <path class="st2" d="M347.2,736.4c0.3-0.8,0.4-1.6-0.6-1.9c-1-0.2-2,0.3-2.4,1.2c-0.6,0.9,0.4,1.3,1.1,1.7
                C346.3,737.8,346.9,737.3,347.2,736.4z"/>
              <path class="st2" d="M401.5,721.3c1.7,0.4,4.5,0.9,6.6-0.7c0.3-0.1,0.6-0.3,1-0.4c1.4,1.3,2.5,0.2,3.7-0.3
                c0.1,0.2,0.4,0.2,0.5,0.1c0,0,0.1-0.1,0.1-0.1c2.3-0.9,4.1-2.6,5.1-4.7c0.8-0.6,1.5-1.1,2.3-1.7c0.5,0,1.2,0.1,1.4-0.1
                c2.5-3.2,5.9-6,4.4-10.8c-0.7-1.8-0.9-3.8-0.6-5.8c-2.5-7.1-6.2-13.3-13.2-16.8c-8.9-5.3-19.1-1.8-26.2,4.3
                c-5.9,5-5.7,12.1-5.4,18.6c0.2,3.8,1,8.6,5.4,10.9C390.3,718.6,396,720,401.5,721.3z M410.2,708L410.2,708L410.2,708L410.2,708
                L410.2,708c0-0.1,0.1,0,0.1,0l0,0L410.2,708L410.2,708z M389.5,692.7L389.5,692.7L389.5,692.7L389.5,692.7z"/>
            </g>
          </g>
        </svg>
      </div>

      <div class="animation-color-overlay">

      </div>

    </div>

    <section1></section1>
    <div class="header-bg-out"></div>
    <section2></section2>
     <section3></section3>
    <section6></section6>
    <section7></section7>
    <section8></section8>
    <section4></section4>
    <section5></section5>
  </div>
</template>

<script>
import section1 from './section_1.vue'
import section2 from './section_2.vue'
import section3 from './section_3.vue'
import section4 from './section_4.vue'
import section5 from './section_5.vue'
import section6 from './section_6.vue'
import section7 from './section_7.vue'
import section8 from './section_8.vue'

export default {
  mounted () {

    window.widthBeforeResize = window.innerWidth
    window.addEventListener('resize', this.onWindowResize)

// Fix dla IE. IE ma "miękkiego scrolla", który wymusza przy skrolowaniu opóźnienie z easingiem co powoduje skakanie przypiętych skryptowo do widoku elementów. Poniższy kod nadpisuje to zachowanie.
    if (navigator.userAgent.match(/Trident\/7\./)) {
      // if IE 
      document.body.addEventListener ("wheel", function (event) {
          // remove default behavior 
          event.preventDefault(); 
          //scroll without smoothing 
          var wheelDelta = (event).deltaY;
          var currentScrollPosition = window.pageYOffset;
          window.scrollTo(0, currentScrollPosition + wheelDelta); 
      }, false); 
    }

    if (window.innerWidth > 1024) {
      const scene = this.$scrollmagic.scene({
        triggerElement: '.header-bg-out',
        triggerHook: .8,
        duration: '40%',
        // reverse: true,
      })

      let Timeline = new TimelineMax();

      let gradientBgTween = TweenMax.to('.gradient-bg', 1, {
        // autoAlpha: 0,
        yPercent: -100,
        // xPercent: -5
      }, 1)

      Timeline
        .add(gradientBgTween)

      this.$scrollmagic.addScene(
        scene
          .setTween(Timeline)
          // .addIndicators()
      )
    }
  },
  methods: {
    onWindowResize: function () {
      let newWindowWidth = window.innerWidth
      if (window.widthBeforeResize <= 1024 && newWindowWidth > 1024) {
        // turn on animations
        location.reload()
      }
      if (window.widthBeforeResize > 1024 && newWindowWidth <= 1024) {
        // turn off animations
        location.reload()
      }
      window.widthBeforeResize = newWindowWidth
    }
  },
  components: {
    section1,
    section2,
    section3,
    section4,
    section5,
    section6,
    section7,
    section8
  }
}
</script>

<style lang="scss">
  html {
    font-size: 16px;

    @media only screen and (max-width : 1366px) {
      font-size: 14px;
    }

    @media only screen and (max-width : 1024px) {
      font-size: 12px;
    }
  }

  .amic_container {
    max-width: 100%;
  }

  .zpl-wrapper {
    font-family: "Uni neue";

    p, a {
      font-family: "Lato";
    }
  }

  .animation-overlay {
    width: 100%;
    // height: calc(100% - 70px);
    height: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    // background: url('../../../assets/images/zpl/kobieta-sec-1.png');
    // background-size: contain;
    // background-repeat: no-repeat;
    // background-position: 50% 100%;
    z-index: -1;
    pointer-events: none;
    
    @media only screen and (max-width : 1024px) {
      display: none;
    }

    .gradient-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      background: -webkit-gradient(linear,left top,right top,from(#ae0b11),to(#e41429));
      background: linear-gradient(90deg,#ae0b11,#e41429);
      z-index: 2;
    }

    .woman-bg {
      width: 100%;
      height: calc(100% - 70px);
      position: absolute;
      bottom: 0px;
      left: 0px;
      background: url('../../../assets/images/zpl/kobieta-sec-1.png');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 100%;
      z-index: 2;

    }

    .woman-big-dot {
      width: 100%;
      height: calc(100% - 70px);
      position: absolute;
      bottom: 0px;
      left: 0px;
      z-index: 1;
      background: url('../../../assets/images/zpl/full-dot.svg');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: 50% 100%;
      transform: scale(.75);
    }

    // .woman-heart-cnt {
    //   width: 100%;
    //   height: calc(100% - 70px);
    //   position: absolute;
    //   bottom: 0px;
    //   left: 0px;
    //   z-index: 2;

    //     .woman-heart {
    //       position: absolute;
    //       left: 47%;
    //       top: 56%;
    //       z-index: 1;
    //       transform: scale(0);

    //       .a{
    //         fill:#e41429;
    //       }
    //     }
      
    // }

    .woman-heart-cnt {
      width: 100%;
      height: calc(100% - 70px);
      position: absolute;
      bottom: 0px;
      left: 0px;
      z-index: 2;

      svg {
        width: 100%;
        height: 100%;
        transform: scale(0);

        .st0{fill:#E41429 !important;}
      }
    }

    .dots-cnt {
      width: 100%;
      height: calc(100% - 70px);
      position: absolute;
      bottom: 0px;
      left: 0px;
      z-index: 1;

        svg {
          width: 100%;
          height: 100%;

          .bg-dots-1 {
            // opacity: 0;
          }

          .bg-dots-2 {
            // opacity: 0;
          }
        }

        .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#23221E !important;}
        .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#E41429 !important;}
        .st2{fill-rule:evenodd;clip-rule:evenodd;fill:#2A2A2A !important;}

        @media only screen and (max-width : 1366px) {
          display: none;
        }
      
    }

    .animation-color-overlay {
      width: 200vw;
      height: 200vh;
      background: rgba(230, 203, 194, .2);

      position: fixed;
      top: 100vh;
      left: 0px;

      // transform: rotate(-90deg);

      transform-origin: top left;
    }

  }
</style>
